// Connection state of the inbox WebSocket (appRedux/sagas/Ws.js), read by the chat's live indicator.
// 'connecting' (first connect) | 'open' | 'reconnecting' (abnormal close, retrying) | 'closed' (closed on purpose)
let status = 'connecting';
// When the socket last stopped being open (null while open or before the first connect).
let downSince = null;
let retry = null;
const listeners = new Set();

export const getWsStatus = () => ({status, downSince});

export const setWsStatus = (next) => {
  if (next === status) return;
  if (next === 'open') downSince = null;
  else if (status === 'open') downSince = Date.now();
  status = next;
  listeners.forEach(listener => listener());
};

export const subscribeWsStatus = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// The saga registers how to reconnect now (skipping the retry delay); the Retry button calls it.
export const setWsRetry = (fn) => { retry = fn; };
export const retryWsNow = () => retry && retry();
